import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Telly = () => {
  useEffect(() => {
    // App carousel slider
    const slider = document.getElementById("slider");
    if (!slider) return;

    let currentIndex = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const slide = () => {
      if (totalSlides > 0) {
        currentIndex = (currentIndex + 1) % (totalSlides - 2);
        slider.style.transform = `translateX(-${currentIndex * 33.333}%)`;
      }
    };

    const slideInterval = setInterval(slide, 3000);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="telly-page portfolio-details-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.5s">
            <h1>
              <img src="/assets/images/logos/logo-telly.svg" alt="telly" />
            </h1>
            <h2>Your film and TV library, shared with friends.</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>Telly</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>Product Architecture</li>
                <li>Mobile Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                Telly is an innovative mobile application designed for avid movie enthusiasts who want to curate,
                track, and share the shows and movies they love. With its sleek and intuitive design, Telly lets
                users effortlessly log and review what they've watched, create personalized watchlists for any
                occasion, and keep track of the shows they're currently following.
              </p>
              <p>
                The app also enables users to
                share their curated content with friends, discover trending titles and notes from the broader
                Telly community, and get updates on their favorite shows and movies.
              </p>
              <p>
                Whether it's catching up on
                the latest blockbusters or discovering hidden gems, Telly has got movie enthusiasts covered!
              </p>
            </div>
          </div>
          <div className="portfolio-carousel">
            <div className="slide-content">
              <img src="/assets/images/background/telly/main.png" alt="telly" />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img src="/assets/images/background/telly/m1.webp" alt="telly" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    We had to ensure a seamless user experience by implementing a pixel-perfect UI with smooth
                    page transitions and animations. The team also aimed to reduce calls to third-party
                    platforms to obtain movie-related data while keeping it in sync. To enhance the social
                    aspect of the app, we had to provide a feed for users to watch curations made by their
                    friends.
                  </p>
                  <p>
                    Overcoming these obstacles required careful planning and meticulous execution. The team
                    had to find a way to balance performance with design aesthetics while also integrating
                    multiple features seamlessly. We had to explore various technologies and solutions to
                    find the best approach that would provide the desired results.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6">
              <div className="img-card">
                <img src="/assets/images/background/telly/m2.webp" alt="telly" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    The team worked in close collaboration with the client to deliver a mobile app that
                    was both efficient and aesthetically pleasing. By carefully designing the app's UI and
                    incorporating smooth animations, the team ensured a seamless user experience. The result
                    was a visually stunning and easy-to-use app that movie enthusiasts could use to keep
                    track of their favorite shows and movies.
                  </p>
                  <p>
                    To minimize calls to third-party platforms, the team implemented a smart syncing
                    mechanism that kept all movie-related data up-to-date. This helped to speed up the app's
                    performance and improve the overall user experience. Additionally, the team developed a
                    feed feature that allowed users to discover curated content from their friends,
                    providing an engaging and social experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="title">
            <h2>Browse on any device</h2>
            <p>
              Experience responsive, pixel-perfect UI designs on any device with our custom software solutions
            </p>
          </div>
          <div className="app-carousel" id="slider">
            <div className="slide-content">
              <img src="/assets/images/background/telly/s1.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s2.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s3.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s4.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s5.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s6.webp" alt="telly" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/telly/s7.webp" alt="telly" />
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-carousel">
            <div className="slide-content">
              <div className="slide-info">
                <h3>
                  The team delivered a super functional product, within an impressive timeframe, that has
                  stood
                  the test of time through the growth of our user base. They have been extremely responsive
                  all throughout.
                </h3>
                <div className="flex">
                  <div className="client flex">
                    <div className="client-img">
                      <img
                        src="/assets/images/reviews/telly/client-telly.jpg"
                        alt="telly"
                      />
                    </div>
                    <div className="client-details">
                      <h4>Karen Zhao</h4>
                      <h5>Co-founder, Telly Studios</h5>
                    </div>
                  </div>
                  <div className="logo-img grayscale">
                    <img src="/assets/images/logos/logo-telly.svg" alt="telly" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Telly;
